import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { withFormik } from 'formik';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { sprintf } from 'sprintf-js';

import Checkbox from 'common/components/styleguide/form/Checkbox';
import { withCssUnit } from 'common/components/styleguide/utils';
import formikWithAutoSubmit from 'common/hoc/formikWithAutoSubmit';
import { setFormikMultipleValues, hashCode, capfl } from 'common/utils';

import Modal from 'common/components/_partials/modal/_default/index';

import SS from './../_style';
const StyledLabelText = SS.LabelText;
const StyledProductCount = SS.ProductCount;

import {
  FITLER_VALUE_KEY,
  FILTERS_LABEL_KEY,
  FILTERS_NAME_KEY
} from 'common/constants/SiteConstants';

const StyledTabs = styled(Tabs)`
  && {
    display: flex;
    min-height: 380px;
  }
`;

const StyledTab = styled(Tab)`
  && {
    cursor: pointer;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    background: #f8f8f8;
    outline: none;
    &.react-tabs__tab--selected {
      border-right: 1px solid #fff;
      background: #fff;
    }
  }
`;

const StyledTabList = styled(TabList)`
  && {
    width: 180px;
    margin: 0;
    padding: 0;
    list-style: none;
    box-shadow: inset -1px 0px 0px 0px #eee;
  }
`;

const StyledTabPanel = styled(TabPanel)`
  && {
    flex: 1 0 0;
    display: none;
    &.react-tabs__tab-panel--selected {
      display: flex;
    }
  }
`;

const StyledFilterParameterItem = styled.div`
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

class FilterParameter extends PureComponent {
  componentDidMount() {
    const { addFilterResolve } = this.props;
    if (addFilterResolve) {
      addFilterResolve();
    }
  }
  render() {
    const {
      values,
      filterValueId,
      filterValueLabel,
      filterName,
      filterValue,
      filterValueSelected,
      setFormikMultipleValues,
      setFieldValue,
      setFieldTouched,
      productCount
    } = this.props;
    return (
      <StyledFilterParameterItem>
        <Checkbox
          id={filterValueId}
          label={<StyledLabelText>{filterValueLabel}</StyledLabelText>}
          name={filterName}
          value={filterValue}
          setValueChecked={filterValueSelected}
          onChange={e => {
            setFormikMultipleValues(e.target, values, setFieldValue);
            setFieldTouched(filterName);
          }}
          onBlur={e => {
            setFieldTouched(filterName);
          }}
        />
        <StyledProductCount>{productCount}</StyledProductCount>
      </StyledFilterParameterItem>
    );
  }
}

const StyledTabPanelCol = styled.div`
  flex: 1 0 0;
  padding: 10px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    padding: 20px;
  }
`;

const StyledTabPanelColFirst = styled(StyledTabPanelCol)`
  border-right: 1px solid #eee;
`;

const StyledTabPanelInner = styled.div`
  display: flex;
  flex: 1 0 0;
`;

const AdvanceParametersForm = ({
  data,
  values,
  setFieldValue,
  setFieldTouched,
  handleSubmit,
  addFilterResolve,
  t
}) => {
  if (!_.isEmpty(data)) {
    return (
      <Modal
        modalId="filters_parameters_advance"
        title={capfl(t('advanced filters'))}
        width={800}
      >
        <form onSubmit={handleSubmit}>
          <StyledTabs>
            <StyledTabList>
              {_.map(data, item => {
                const filterId = item.id;
                const filterLabel = item[FILTERS_LABEL_KEY];
                return (
                  <StyledTab key={'params-filters-' + filterId + '-tab'}>
                    {filterLabel}
                  </StyledTab>
                );
              })}
            </StyledTabList>
            {_.map(data, item => {
              const filterId = item.id;
              const filterLabel = item[FILTERS_LABEL_KEY];
              const filterName = sprintf(
                '%1$s-%2$s',
                item[FILTERS_NAME_KEY],
                filterId
              );
              const [arr1, arr2] = _.chunk(
                item.values,
                _.round(item.values.length / 2)
              );
              return (
                <StyledTabPanel
                  key={'params-filters-' + filterId + '-tabpanel'}
                >
                  <StyledTabPanelInner>
                    <StyledTabPanelColFirst>
                      {_.map(arr1, item => {
                        const filterValue = item[FITLER_VALUE_KEY];
                        const filterValueLabel = item[FILTERS_LABEL_KEY];
                        const filterValueSelected = item.selected;
                        const filterValueId = sprintf(
                          '%1$s-%2$s',
                          filterName,
                          hashCode(filterValue)
                        );
                        const filterValueKey = sprintf('%1$s', filterValueId);
                        return (
                          <FilterParameter
                            key={filterValueKey}
                            values={values}
                            filterName={filterName}
                            filterValueId={filterValueId}
                            filterValue={filterValue}
                            filterValueLabel={filterValueLabel}
                            filterValueSelected={filterValueSelected}
                            setFieldValue={setFieldValue}
                            setFormikMultipleValues={setFormikMultipleValues}
                            setFieldTouched={setFieldTouched}
                            productCount={item.productCount}
                            addFilterResolve={addFilterResolve(
                              filterName,
                              filterLabel
                            )}
                          />
                        );
                      })}
                    </StyledTabPanelColFirst>
                    {!_.isEmpty(arr2) ? (
                      <StyledTabPanelCol>
                        {_.map(arr2, item => {
                          const filterValue = item[FITLER_VALUE_KEY];
                          const filterValueLabel = item[FILTERS_LABEL_KEY];
                          const filterValueSelected = item.selected;
                          const filterValueId = sprintf(
                            '%1$s-%2$s',
                            filterName,
                            hashCode(filterValue)
                          );
                          const filterValueKey = sprintf('%1$s', filterValueId);
                          return (
                            <FilterParameter
                              key={filterValueKey}
                              values={values}
                              filterName={filterName}
                              filterValueId={filterValueId}
                              filterValue={filterValue}
                              filterValueLabel={filterValueLabel}
                              filterValueSelected={filterValueSelected}
                              setFieldValue={setFieldValue}
                              setFormikMultipleValues={setFormikMultipleValues}
                              setFieldTouched={setFieldTouched}
                              productCount={item.productCount}
                              addFilterResolve={addFilterResolve(
                                filterName,
                                filterLabel
                              )}
                            />
                          );
                        })}
                      </StyledTabPanelCol>
                    ) : (
                      ''
                    )}
                  </StyledTabPanelInner>
                </StyledTabPanel>
              );
            })}
          </StyledTabs>
        </form>
      </Modal>
    );
  }
  return null;
};

const formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: props => {
    const { activeFilters } = props;
    let propsToReturn = {};
    if (!_.isEmpty(activeFilters) && !_.isEmpty(activeFilters.param)) {
      propsToReturn = _.cloneDeep(activeFilters.param);
    }
    return propsToReturn;
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    const { submitFilters } = props;
    if (submitFilters) {
      const paramValues = _.pickBy(values);
      submitFilters({ param: paramValues });
      if (!_.isEmpty(paramValues)) {
      } else {
        submitFilters({ param: null });
      }
    }
    setSubmitting(false);
  }
});

const EnhancedAdvanceParametersForm = formikEnhancer(
  formikWithAutoSubmit(AdvanceParametersForm)
);

export default withTranslation()(EnhancedAdvanceParametersForm);
